import { ABSOLUTE_URL_REGEX } from "@/constants/regex"

const resolveAnalyticsLinkURL = url => {
  if (!url) {
    return "n/a"
  }

  if (ABSOLUTE_URL_REGEX.test(url) || url.startsWith("//")) {
    return url
  }

  const normalizedPath = url.startsWith("/") ? url : `/${url}`
  return `${window.location.origin}${normalizedPath}`
}

export const analyticsMoreFromCollectionParts = (
  url = "",
  title = "",
  sku = "",
  productInfo = null
) => {
  const eventInfo = {
    eventAction: `pdp:product details:replaced by:${title}`,
    eventName: `pdp:product details:replaced by:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${title}:${sku}`,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:replaced by`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: resolveAnalyticsLinkURL(url),
    clickInternalLinks: "true",
  }
  const page = window.pageObj || {}
  const event = "cmp:click"
  if (!window.adobeDataLayer) {
    window.adobeDataLayer = []
  }
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    ...(productInfo && Object.keys(productInfo).length > 0
      ? { productInfo }
      : {}),
  })
}
